function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "tommy4");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "tommy4"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-1",
  fill: "#040C2B",
  points: "0 179.6117 0 191.8237 82.677 169.6707 82.677 157.4577"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-2",
  fill: "#ECECEB",
  points: "198.4249 126.4438 198.4249 138.6558 82.6769 169.6708 82.6769 157.4588"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-3",
  fill: "#040C2B",
  points: "314.1729 95.4293 314.1729 107.6413 396.8509 85.4883 396.8509 73.2753"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-4",
  fill: "#BA001D",
  points: "198.4249 138.6557 198.4249 126.4437 314.1729 95.4287 314.1729 107.6407"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-5",
  fill: "#040C2B",
  points: "0 106.3355 0 112.6365 16.905 108.1065 16.905 150.6565 23.924 148.7755 23.924 106.2255 40.829 101.6965 40.829 95.3965"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.3302,120.0854 C120.2872,117.1494 128.3832,107.0294 128.3832,96.3604 C128.3832,85.6154 120.2872,79.9054 109.3302,82.8414 C98.4412,85.7594 90.3482,95.8074 90.3482,106.5524 C90.3482,117.2214 98.4412,123.0034 109.3302,120.0854 M109.3302,76.3954 C125.4442,72.0764 135.6172,80.8124 135.6172,94.4224 C135.6172,107.6034 125.7292,122.1384 109.1842,126.5714 C93.2132,130.8514 83.1132,121.7424 83.1132,108.4904 C83.1132,94.9514 93.5002,80.6364 109.3302,76.3954",
  id: "Fill-6",
  fill: "#040C2B"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-8",
  fill: "#040C2B",
  points: "223.4571 95.311 216.4391 97.191 216.4391 59.156 216.2941 59.195 201.2531 82.137 200.1051 82.444 185.0651 67.562 184.9221 67.601 184.9221 105.636 177.9021 107.517 177.9021 58.666 184.4931 56.901 200.6811 72.62 216.9391 48.207 223.4571 46.46"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-10",
  fill: "#040C2B",
  points: "311.2989 71.7739 304.2789 73.6549 304.2789 35.6189 304.1359 35.6579 289.0929 58.5999 287.9479 58.9069 272.9049 44.0259 272.7639 44.0639 272.7639 82.0989 265.7419 83.9809 265.7419 35.1299 272.3329 33.3639 288.5209 49.0829 304.7809 24.6699 311.2989 22.9229"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-12",
  fill: "#040C2B",
  points: "388.3946 2.2651 396.8486 0.0001 378.7236 27.9201 378.7236 53.7071 371.7076 55.5871 371.7076 29.7301 353.5846 11.5921 362.0376 9.3271 375.1426 22.6491"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-17",
  fill: "#040C2B",
  points: "77.4952 244.3354 70.4822 246.2144 70.4822 197.3634 77.4952 195.4844"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-19",
  fill: "#040C2B",
  points: "113.3107 228.4331 135.3747 222.5211 135.3747 228.8271 106.2897 236.6201 106.2897 187.7691 113.3107 185.8881"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-21",
  fill: "#040C2B",
  points: "181.6085 173.8882 162.5505 178.9942 162.5505 192.5342 181.6085 187.4272 181.6085 193.7332 162.5505 198.8392 162.5505 221.5442 155.5295 223.4262 155.5295 174.5752 181.6085 167.5872"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-23",
  fill: "#040C2B",
  points: "213.1886 207.9761 206.1746 209.8561 206.1746 161.0041 213.1886 159.1251"
}), /*#__PURE__*/React.createElement("path", {
  d: "M280.0177,186.7007 C273.4997,191.3117 268.2037,193.8767 261.4027,195.6987 C246.4307,199.7107 235.3947,192.2107 235.3947,177.8877 C235.3947,163.4917 246.7137,149.4967 261.6157,145.5047 C267.3457,143.9687 271.3517,143.8277 279.0187,144.9967 L279.0187,152.0857 C273.2887,150.4717 267.3457,150.4157 261.4727,151.9887 C250.8707,154.8297 242.6277,165.1347 242.6277,175.7327 C242.6277,186.6197 250.7987,192.0937 262.4017,188.9837 C266.1957,187.9677 269.6357,186.1877 273.0047,184.2107 L273.0047,174.1817 L263.6137,176.6987 L263.6137,170.3977 L280.0177,166.0027 L280.0177,186.7007 Z",
  id: "Fill-25",
  fill: "#040C2B"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-27",
  fill: "#040C2B",
  points: "334.4581 132.9321 313.7561 138.4801 313.7561 153.2391 333.7421 147.8831 333.7421 154.1851 313.7561 159.5391 313.7561 174.7241 335.1041 169.0031 335.1041 175.3091 306.7331 182.9111 306.7331 134.0601 334.4581 126.6311"
}), /*#__PURE__*/React.createElement("path", {
  d: "M366.1173,139.4917 L370.6283,138.2827 C378.1533,136.2657 380.3033,131.8267 380.2313,127.7597 C380.1523,123.1957 377.4373,121.1337 370.6283,122.9577 L366.1173,124.1667 L366.1173,139.4917 Z M371.4153,116.7287 C381.3023,114.0797 387.4663,117.6587 387.4663,126.1087 C387.4663,131.7677 384.5293,136.7777 379.2943,140.2587 C383.7333,142.0057 386.4583,145.7897 390.1803,150.8817 C392.2593,153.6887 393.4783,155.0117 396.8483,158.7647 L388.4653,161.0117 L382.0173,152.7107 C375.5713,144.4087 372.6353,144.0507 369.0543,145.0107 L366.1173,145.7977 L366.1173,166.9997 L359.0963,168.8807 L359.0963,120.0297 L371.4153,116.7287 Z",
  id: "Fill-29",
  fill: "#040C2B"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-14",
  fill: "#040C2B",
  points: "41.3966 254.0083 34.3826 255.8873 34.3826 234.6143 7.0216 241.9453 7.0216 263.2183 0.0006 265.1003 0.0006 216.2493 7.0216 214.3673 7.0216 235.6403 34.3826 228.3093 34.3826 207.0363 41.3966 205.1563"
})));

var SvgTommy4 = function SvgTommy4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "397px",
    height: "266px",
    viewBox: "0 0 397 266",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTommy4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tommy4.d47249f8.svg";
export { ForwardRef as ReactComponent };